import { useTranslation } from 'react-i18next';
import { Card, Skeleton } from 'antd';
import { useGetClientInsurance } from 'api/clients/use-get-client-insurance';
import styles from './client-insurance.module.scss';
import { ClientInsuranceDetails } from './components/client-insurance-details';
import { ClientInsuranceEmptyState } from './components/client-insurance-empty-state';
import { ClientInsuranceStatus } from './components/client-insurance-status';
import type { IClientInsuranceProps } from './types';

export const ClientInsurance = (props: IClientInsuranceProps) => {
  const { clientId } = props;
  const { t } = useTranslation('client');
  const { data: insurance, isLoading } = useGetClientInsurance(clientId);

  const renderContent = () => {
    if (isLoading) {
      return <Skeleton paragraph={{ rows: 3 }} active />;
    }

    if (insurance) {
      return <ClientInsuranceDetails clientId={clientId} insurance={insurance} />;
    }

    return <ClientInsuranceEmptyState clientId={clientId} />;
  };

  return (
    <Card
      className={styles.card}
      title={t('insurance')}
      extra={isLoading ? null : <ClientInsuranceStatus status={insurance?.status} />}>
      {renderContent()}
    </Card>
  );
};
